import $ from "jquery";

const header = $("header.header-section"),
  fullscreenMenuButton = $(".menu-button"),
  fullScreenMenu = $(".full-screen-menu"),
  dropdownToggle = $(".full-screen-menu .dropdown-toggle .caret"),
  dropdownMenu = $(".full-screen-menu .dropdown-menu"),
  headerMenuItemHasChildren = $("header nav .menu-item-has-children");

function closeMobNav() {
  header.removeClass("menu-opened");
  // dropdownToggle.removeClass("opened");
  dropdownToggle.closest(".dropdown-toggle").removeClass("opened");
  fullscreenMenuButton.removeClass("menu-opened").addClass("menu-closed");
  fullScreenMenu.slideUp();

  headerMenuItemHasChildren
    .removeClass("menu-opened")
    .children(".dropdown-menu")
    .stop()
    .fadeOut();

  $("html").css({
    overflow: "visible",
    left: "auto",
    right: "auto",
    top: "auto",
    bottom: "auto",
    position: "static",
  });
}

fullscreenMenuButton.on("click", function () {
  if (fullscreenMenuButton.hasClass("menu-opened")) {
    closeMobNav();
  } else {
    fullScreenMenu.css("position", "absolute").slideDown();
    fullscreenMenuButton.removeClass("menu-closed").addClass("menu-opened");
    header.addClass("menu-opened");
    $("html").css({
      overflow: "hidden",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    });
    calcHeight();
  }
});

dropdownToggle.on("click", function (e) {
  e.preventDefault();
  const targetEl = $(this).closest(".dropdown-toggle");
  if (!targetEl.siblings(".dropdown-menu").is(":visible")) {
    targetEl.removeClass("opened");
    dropdownMenu.slideUp();
    targetEl.addClass("opened");
    targetEl.siblings(".dropdown-menu").slideDown();
  } else {
    targetEl.removeClass("opened");
    targetEl
      .closest(".menu-item-has-children")
      .find(".dropdown-menu")
      .slideUp();
  }
});

function openNav() {
  headerMenuItemHasChildren.each(function () {
    $(this).on({
      "mouseover focusin": function () {
        if ($(window).width() >= 1200) {
          $(this)
            .addClass("menu-opened")
            .children(".dropdown-menu")
            .stop()
            .fadeIn();
        }
      },
      "mouseout focusout": function () {
        if ($(window).width() >= 1200) {
          $(this)
            .removeClass("menu-opened")
            .children(".dropdown-menu")
            .stop()
            .fadeOut();
        }
      },
    });
  });
}

function calcHeight() {
  if (fullScreenMenu.length) {
    let elem = fullScreenMenu[0];
    let viewportOffsetTop = elem.getBoundingClientRect().top;

    fullScreenMenu.css("max-height", "calc(100vh - " + viewportOffsetTop + "px)");
  }
}

openNav();

$(window).resize(function () {
  openNav();
  calcHeight();

  const win = $(this);
  if (win.width() >= 1200) {
    closeMobNav();
  }
});
